import * as XLSX from 'xlsx';
import { ContactListType } from './types';

export const exportAsCSV = (contactList: ContactListType, groupType: string) => {
  // CSV header
  const csvHeader = `Service,Currency,Amount,Beneficiary Full Name,Address,City,Province,Country,Postal Code,Client Reference Number,Financial Institution Number,Transit Number,Account Number,Token,FlinksAccountID,FlinksLoginID,PlaidPublicToken,PlaidAccessToken,PlaidAccountID,PlaidProcessorToken,InveriteRequestGUID,Idempotency Key,Start Date,Client Account ID,Transaction Label,Notes`;

  // Prepare the rows
  const rows = Object.values(contactList).map((contact) => [
    groupType === 'Payment' ? 'Credit' : 'Debit', // Service
    contact.Currency, // Currency
    contact.Amount, // Amount
    `${contact.FirstName} ${contact.LastName}`, // Beneficiary Full Name
    '', // Address
    '', // City
    '', // Province
    '', // Country
    '', // Postal Code
    contact.ClientReferenceNumber, // Client Reference Number
    '', // Financial Institution Number
    '', // Transit Number
    '', // Account Number
    contact.Token, // Token
    '', // FlinksAccountID
    '', // FlinksLoginID
    '', // PlaidPublicToken
    '', // PlaidAccessToken
    '', // PlaidAccountID
    '', // PlaidProcessorToken
    '', // InveriteRequestGUID
    '', // Idempotency Key
    '', // Start Date
    '', // Client Account ID
    '', // Transaction Label
    '', // Notes
  ]);

  // Create worksheet from rows
  const worksheet = XLSX.utils.aoa_to_sheet([csvHeader.split(','), ...rows]);

  // Create a workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Write the workbook to a CSV file
  XLSX.writeFile(workbook, 'contacts.csv', { bookType: 'csv' });
};
